import { Button } from '@highlight/ui'
import { Gift } from 'lucide-react'
import { Announcement } from '.'
import { isDev } from '@shared/utils/platform'
import { useLatestChangelog } from '@renderer/windows/features/changelogs/atoms'
import { useSetChangelogViewed } from '@renderer/windows/features/changelogs/atoms'

export const ChangelogAnnouncement = () => {
  const setChangelogViewed = useSetChangelogViewed()
  const latestChangelog = useLatestChangelog()

  const onReadMore = () => {
    window.open(`highlight${isDev ? '-dev' : ''}://settings?changelog=true`)
  }

  const onDismiss = () => {
    if (!latestChangelog) {
      return
    }
    setChangelogViewed(latestChangelog.id)
  }

  // Brand rather than the old hardcoded indigo: it's the accent the Day Zero
  // banner already uses for "Highlight has something for you", and indigo was
  // the one colour in the header answering to no token.
  return (
    <Announcement.Container className="border-brand bg-brand/10">
      <Announcement.Title>
        <div className="relative flex items-center justify-center">
          <div className="bg-brand/50 absolute h-5 w-5 animate-pulse rounded-full blur-sm motion-reduce:animate-none" />
          <Gift size={16} className="text-brand-9 relative flex-shrink-0" />
        </div>
        <span>Your Highlight just got better!</span>
      </Announcement.Title>
      <Announcement.Actions>
        <Button variant="outline" size="sm" onClick={onReadMore}>
          See what's new
        </Button>
        <Button variant="ghost" size="sm" onClick={onDismiss}>
          Dismiss
        </Button>
      </Announcement.Actions>
    </Announcement.Container>
  )
}
